import { withStyles } from '@material-ui/core';
import RequiredAsterisk from './RequiredAsterisk';

const style = {
    requiredAsterisk: {
        display: 'inline',
    },
};

export default withStyles(style)(RequiredAsterisk);
